import classNames from 'classnames'
import ClearIconSVG from '../../atoms/Icons/ClearIcon'
import SearchIcon from '../../atoms/Icons/SearchIcon'

export const DASHBOARD_FIELD_BASE =
  'h-16 rounded-lg border border-orange bg-transparent text-xl text-dark-blue ' +
  'outline-none focus:border-[#c7661a] focus:outline-offset-0 focus:[outline:2px_solid_#c7661a]'

type Props = {
  id: string
  value: string
  onChange: (value: string) => void
  placeholder: string
  ariaLabel: string
  className?: string
}

const DashboardSearchInput = ({ id, value, onChange, placeholder, ariaLabel, className }: Props): JSX.Element => (
  <div className={classNames('relative', className)}>
    <label htmlFor={id} className="sr-only">
      {ariaLabel}
    </label>
    <input
      id={id}
      type="search"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      className={`${DASHBOARD_FIELD_BASE} w-full pl-4 pr-12`}
    />
    {value ? (
      <button
        type="button"
        onClick={() => onChange('')}
        aria-label="Clear search"
        className="absolute right-4 top-1/2 -translate-y-1/2"
      >
        <ClearIconSVG />
      </button>
    ) : (
      <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2">
        <SearchIcon />
      </div>
    )}
  </div>
)

export default DashboardSearchInput
